export enum Event {
    COMPANY_LOCATION_CHANGE= "COMPANY_LOCATION_CHANGE"
}
